export { default } from './RelatedArticleSection'
